module.exports = __webpack_public_path__ + "img/file_timer.ad60aafc.png";